import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CircularProgress } from '@mui/material';
const ConfirmUploadDialog = props => {
  const ConfirmButton = ({ onSubmit, text, loading = false, disabled }) => {
    return (
      <Button onClick={onSubmit} disabled={disabled}>
        {!loading ? text : <CircularProgress size={30} />}
      </Button>
    );
  };
  return (
    <Dialog
      open={props?.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure want to import data from {props?.file?.name}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={props.handleClose}>
          Cancel
        </Button>
        <ConfirmButton
          text={'Upload'}
          onSubmit={props.submitFile}
          loading={props?.loadingUpload}
          disabled={props?.loadingUpload}
        />
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmUploadDialog;
